function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconEditRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M28 28v2H4v-2h24zM17.745 5.448l1.41 1.408 3.988 3.99 1.409 1.408.006.005-11.794 11.794L4 26l1.947-8.764L17.741 5.443l.004.005zM6.634 23.366l4.44-.987-3.453-3.454-.987 4.441zM22.014 2a2 2 0 011.416.587l3.983 3.984c.782.782.782 2.05 0 2.832l-1.442 1.441-1.413-1.414-3.989-3.987-1.414-1.413L20.6 2.587c.39-.391.902-.587 1.415-.587z",
    fill: props.color
  }));
}

export default SvgIconEditRexFilled;